import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// @ts-ignore
const hideMenuOnScroll = () => {
    const menu: HTMLElement | null = document.querySelector("#menu_topbar");
    const offer_banner: HTMLElement | null = document.querySelector("#offer_homepage_banner");
    if(!menu || !offer_banner) return;

    const showOfferBanner = gsap
            .from(offer_banner, {
                top: '0',
                pointerEvents: "none",
                paused: true,
            })
            .progress(1);
    const showAnim = gsap
            .from(menu, {
                top: '-100%',
                pointerEvents: "none",
                paused: true,
            })
            .progress(1);

    ScrollTrigger.create({
        start: "700px top",
        onUpdate: (self) => {
            self.direction === -1 ? (
                showAnim.play(),
                showOfferBanner.play()
            ) : (
                showAnim.reverse(),
                showOfferBanner.reverse()
            );
        },
    });


}

const revealBlocksAnimation = (items: NodeListOf<HTMLElement>) => {
    items.forEach((element: HTMLElement) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: "top 80%",
            },
            y: 50,
            opacity: 0,
            duration: 1,
            ease: "power4.out",
        });
    });
}

const staggerReveal = (items: NodeListOf<HTMLElement>) => {
    gsap.from(items, {
        scrollTrigger: {
            trigger: items,
            start: "top 90%",
        },
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.1,
    });
};

document.addEventListener("DOMContentLoaded", function () {
    // Register ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    const revealElements: NodeListOf<HTMLElement> = document.querySelectorAll(".gsap-reveal");
    const revealStaggerElements: NodeListOf<HTMLElement> = document.querySelectorAll(".gsap-reveal-stagger");

    if(!revealElements) return;

    revealBlocksAnimation(revealElements);
    staggerReveal(revealStaggerElements);
    hideMenuOnScroll();
});